module dg.objects {

    export class AngularHelper {
        static registerPropertyDisplayer<TCtrl extends dg.objects.PropertyDisplayerControllerBase<any>>(controller: { new (...args: any[]): TCtrl; }, name: string, customOptions: ng.IComponentOptions) {

            let options: ng.IComponentOptions = {
                bindings: {
                    value: '<',
                    //propMeta: '<',
                    propertyId: '@',
                    options: '<?'
                },
                require: {
                    objectDisplayerCtrl: '^objectDisplayer'
                },
                controller: controller
            };

            options = dgUtils.ObjectHelperService.mergeDeep(options, customOptions);

            angular.module('dg.objects').component(name, options);
        }
    }

    angular.module('dg.objects', [
        'ui.select',
        'ui.tinymce',
        'ui.bootstrap.datetimepicker',
        'angularMoment',
        'nya.bootstrap.select'
    ])
        .config((uibDatepickerConfig: ng.ui.bootstrap.IDatepickerConfig,
            uibDatepickerPopupConfig/*: ng.ui.bootstrap.IDatepickerPopupConfig*/, uiDatetimePickerConfig) => {
            uibDatepickerPopupConfig.closeText = 'Close';
            uibDatepickerPopupConfig.datepickerPopup = "dd-MM-yyyy";
            uiDatetimePickerConfig.dateFormat = "dd-MM-yyyy HH:mm";
        });
}